import { stateKey } from '../../../../../app/state-key.js';
import { excludeFacetSearchResult, registerFacetSearch, selectFacetSearchResult, } from '../../../../../features/facets/facet-search-set/specific/specific-facet-search-actions.js';
import { deselectAllFacetValues } from '../../../../../features/facets/facet-set/facet-set-actions.js';
import { buildGenericFacetSearch } from '../facet-search.js';
export function buildFacetSearch(engine, props) {
    const { dispatch } = engine;
    const { options, select: propsSelect, exclude: propsExclude, isForFieldSuggestions, executeFacetSearchActionCreator, executeFieldSuggestActionCreator, } = props;
    const { facetId } = options;
    const getFacetSearch = () => 'state' in engine
        ? engine.state.facetSearchSet[facetId]
        : engine[stateKey].facetSearchSet[facetId];
    dispatch(registerFacetSearch(options));
    const genericFacetSearch = buildGenericFacetSearch(engine, {
        options,
        getFacetSearch,
        isForFieldSuggestions,
        executeFacetSearchActionCreator: executeFacetSearchActionCreator,
        executeFieldSuggestActionCreator: executeFieldSuggestActionCreator,
    });
    return {
        ...genericFacetSearch,
        /**
         * Selects the provided value.
         * @param result A single specificFacetSearchResult object
         */
        select(value) {
            dispatch(selectFacetSearchResult({ facetId, value }));
            propsSelect(value);
        },
        /**
         * Excludes the provided value.
         * @param result A single specificFacetSearchResult object
         */
        exclude(value) {
            dispatch(excludeFacetSearchResult({ facetId, value }));
            propsExclude(value);
        },
        /**
         * Selects the provided value, and deselects other values.
         * @param result A single specificFacetSearchResult object
         */
        singleSelect(value) {
            dispatch(deselectAllFacetValues(facetId));
            dispatch(selectFacetSearchResult({ facetId, value }));
            propsSelect(value);
        },
        /**
         * Excludes the provided value, and deselects other values.
         * @param result A single specificFacetSearchResult object
         */
        singleExclude(value) {
            dispatch(deselectAllFacetValues(facetId));
            dispatch(excludeFacetSearchResult({ facetId, value }));
            propsExclude(value);
        },
        get state() {
            const { values } = genericFacetSearch.state;
            return {
                ...genericFacetSearch.state,
                values: values.map(({ count, displayValue, rawValue }) => ({
                    count,
                    displayValue,
                    rawValue,
                })),
            };
        },
    };
}
